var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    width: 20,
    fill: "blue",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2 3 A5 2, -2, 0 1, 9 3",
    fill: "none",
    stroke: "#f37f33",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8 3 A5 2, -2, 0 0, 15 2",
    fill: "none",
    stroke: "#f37f33",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 2,
    x2: 15,
    y2: 8,
    style: {
      stroke: "#f37f33",
      strokeWidth: 3
    },
    strokeLinecap: "round"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 1 9 A5 2, -2, 0 1, 9 9",
    fill: "none",
    stroke: "#f37f33",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 8 9 A5 2, -2, 0 0, 15 8",
    fill: "none",
    stroke: "#f37f33",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 3,
    x2: 2,
    y2: 15,
    style: {
      stroke: "#f37f33",
      strokeWidth: 3
    },
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagged);
export default __webpack_public_path__ + "static/media/flagged.83a14f9dd9c64e00273a3ae68f382ac5.svg";
export { ForwardRef as ReactComponent };